export default "__VITE_ASSET__B_UgE6bJ__"